import FieldsConstants from 'src/app/common/fields.constants';
import { SearchCategories } from 'src/app/components/search/search.enum';
import { SelectorOption } from 'src/app/interfaces/form-and-field.interface';
import { PaginationState } from 'src/app/interfaces/pagination.interface';
import { SearchResultResponse } from 'src/app/interfaces/search.interface';
import { SearchStrategyTypes } from '../../../components/search/search.enum';
import { OrganizationLink } from '../../../swagger-api';

/**
 * @description Converts string value to SelectedOption
 *              by setting it to entity_id and title.
 * @param { string } value Field attributes metadata.
 * @returns { SelectorOption }
 */
export function stringToSelectOptionAdapter(value: string): SelectorOption {
  return {
    entity_id: value,
    title: value,
    kind: OrganizationLink.OrganizationLinkKindEnum.CUSTOM,
  };
}

export const INITIAL_PAGINATION_STATE: PaginationState = {
  totalItemsCount: FieldsConstants.SEARCH_DEFAULT_RESULTS_COUNT_MAX,
  currentPage: 1,
};

export const INITIAL_PAGINATION_STATE_WITH_LIMIT: PaginationState = {
  totalItemsCount: FieldsConstants.SEARCH_DEFAULT_RESULTS_COUNT_MAX,
  currentPage: 1,
  limit: 20,
};

export function accumulateResult(acc: SearchResultResponse, curr: SearchResultResponse): SearchResultResponse {
  return {
    ...acc,
    search_results: [...acc.search_results, ...curr.search_results],
    params: curr.params,
    pagination: curr.pagination,
  };
}

export enum FieldsSearchStrategy {
  linked_community_ids_select = SearchStrategyTypes.ENTITY_NAME,
  linked_project_ids_select = SearchStrategyTypes.ENTITY_NAME,
  linked_organization_ids_select = SearchStrategyTypes.ENTITY_NAME,
}

export enum SearchParameterOptions {
  linked_community_ids_select = SearchCategories.COMMUNITIES,
  linked_project_ids_select = SearchCategories.PROJECTS,
  linked_organization_ids_select = SearchCategories.ORGANIZATIONS,
}

export enum DropdownFieldsProcessorKind {
  editable = 'editable',
  editable_selector = 'editable_selector',
  default = 'default',
}
